import { TTypeOfCodec, TTypeOfNewDefault } from "../../../shared/src/codecs/codec";
import { required } from "../../../shared/src/codecs/types/required";
import { uuid } from "../../../shared/src/codecs/types/uuid";
import { form } from "../../../shared/src/codecs/types/form";
import { date } from "../../../shared/src/codecs/types/date";
import { EmptyObject } from "../EmptyObject";

// Carries a date rather than stamping `now()` server-side: backdating is a real case, and a
// reinstated listing keeps the date it originally went live.
export const TakeListingLiveForm = form(
    required({
        listing_id: uuid(),
        live_date: date(),
    }),
    EmptyObject,
);

export type TTakeListingLiveFormCodec = typeof TakeListingLiveForm;
export type TTakeListingLiveForm = TTypeOfCodec<TTakeListingLiveFormCodec>;
export type TTakeListingLiveFormNewDefault = TTypeOfNewDefault<TTakeListingLiveFormCodec>;
